import { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  type SxProps,
  type Theme,
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';

export interface ItemActionsMenuAction {
  id: string;
  label: string;
  onClick: () => void | Promise<void>;
}

export type ItemActionsMenuVariant = 'header' | 'inline';

interface ItemActionsMenuProps {
  actions: ItemActionsMenuAction[];
  variant?: ItemActionsMenuVariant;
}

const inlineButtonSx: SxProps<Theme> = {
  border: 'none',
  p: 0,
  width: 18,
  height: 18,
  minWidth: 0,
  '&:hover': {
    border: 'none',
    backgroundColor: 'action.hover',
  },
};

export function ItemActionsMenu({
  actions,
  variant = 'inline',
}: ItemActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isInline = variant === 'inline';

  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label="More actions"
        sx={isInline ? inlineButtonSx : undefined}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon
          fontSize={isInline ? 'inherit' : 'small'}
          sx={isInline ? { fontSize: 14 } : undefined}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={(event) => event.stopPropagation()}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.id}
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(null);
              void action.onClick();
            }}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
